import { render, staticRenderFns } from "./activity-streaming-verification.vue?vue&type=template&id=535d890c&scoped=true&"
import script from "./activity-streaming-verification.vue?vue&type=script&lang=js&"
export * from "./activity-streaming-verification.vue?vue&type=script&lang=js&"
import style0 from "./activity-streaming-verification.vue?vue&type=style&index=0&id=535d890c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d890c",
  null
  
)

export default component.exports